import { GridColDef, GridColumnVisibilityModel } from '@mui/x-data-grid';

import { ILocation } from 'common';
import {
  additionalInsuredsCol,
  addrCityCol,
  addrCountyCol,
  addrFIPSCol,
  addrLine1Col,
  addrLine2Col,
  addrPostalCol,
  addrStateCol,
  addressSummaryCol,
  annualPremiumCol,
  booleanCalcActiveCol,
  coordinatesCol,
  createdCol,
  deductibleCol,
  effectiveDateCol,
  expirationDateCol,
  externalIdCol,
  idCol,
  latitudeCol,
  limitACol,
  limitBCol,
  limitCCol,
  limitDCol,
  longitudeCol,
  mortgageeCol,
  ratingDataBasementCol,
  ratingDataCBRSCol,
  ratingDataDistToCoastFeetCol,
  ratingDataFloodZoneCol,
  ratingDataNumStoriesCol,
  ratingDataPropertyCodeCol,
  ratingDataReplacementCostCol,
  ratingDataSqFootageCol,
  ratingDataYearBuiltCol,
  ratingDocIdCol,
  termDaysCol,
  termPremiumCol,
  tivCol,
  updatedCol,
} from './gridColumns';

export const locationCols: GridColDef<ILocation>[] = [
  { ...idCol, headerName: 'Location ID' },
  {
    ...idCol,
    field: 'policyId',
    headerName: 'Policy ID',
    valueGetter: (params) => params.row.policyId || null,
    sortable: false,
    filterable: true,
    // TODO: use link component to display --> route to policy
  },
  externalIdCol,
  // parentTypeCol,
  addressSummaryCol,
  addrLine1Col,
  addrLine2Col,
  addrCityCol,
  addrStateCol,
  addrPostalCol,
  addrCountyCol,
  addrFIPSCol,
  limitACol,
  limitBCol,
  limitCCol,
  limitDCol,
  tivCol,
  deductibleCol,
  termPremiumCol,
  annualPremiumCol,
  booleanCalcActiveCol,
  effectiveDateCol,
  expirationDateCol,
  termDaysCol,
  additionalInsuredsCol,
  mortgageeCol,
  coordinatesCol,
  latitudeCol,
  longitudeCol,
  ratingDataReplacementCostCol,
  ratingDataPropertyCodeCol,
  ratingDataYearBuiltCol,
  ratingDataSqFootageCol,
  ratingDataNumStoriesCol,
  ratingDataBasementCol,
  ratingDataDistToCoastFeetCol,
  ratingDataCBRSCol,
  ratingDataFloodZoneCol,
  ratingDocIdCol,
  createdCol,
  updatedCol,
];

export const LOCATION_COLUMN_VISIBILITY: GridColumnVisibilityModel = {
  id: false,
  product: false,
  policyId: false,
  'address.addressLine1': false,
  'address.addressLine2': false,
  'address.city': false,
  'address.state': false,
  'address.postal': false,
  'address.countyName': false,
  'address.countyFIPS': false,
  coordinates: false,
  latitude: false,
  longitude: false,
  annualPremium: false,
  'ratingPropertyData.CBRSDesignation': false,
  'ratingPropertyData.basement': false,
  'ratingPropertyData.distToCoastFeet': false,
  'ratingPropertyData.floodZone': false,
  'ratingPropertyData.numStories': false,
  'ratingPropertyData.propertyCode': false,
  'ratingPropertyData.sqFootage': false,
  'ratingPropertyData.yearBuilt': false,
  'ratingPropertyData.replacementCost': false,
  'ratingPropertyData.ratingDocId': false,
  ratingDocId: false,
  externalId: false,
  'metadata.created': false,
  'metadata.updated': false,
};
